import { render, staticRenderFns } from "./VendorView.vue?vue&type=template&id=0df01ea8"
import script from "./VendorView.vue?vue&type=script&lang=js"
export * from "./VendorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports